import constants from '@/generated/constants.js'

export default [{
  path: '/dashboard',
  meta: {
    group: 'dashboard',
  },
  components: {
    'default': () => import('../modules/dashboard-v5/empty.vue'),
    'nav-right-end': () => import('../modules/dashboard-v5/sub-views/quick-panel-toggle.vue'),
    'quick-panel': () => import('../modules/dashboard-v5/sub-views/otto-sidebar.vue'),
    'mobile-header': () => import('../modules/dashboard-v5/sub-views/mobile-header.vue'),
    'aside': () => import('../modules/dashboard-v5/sub-views/aside.vue'),
  },
  children: [
    {
      path: '',
      name: 'dashboard.home',
      component: () => import('../modules/dashboard-v5/home.vue'),
      meta: {
        title: 'Dashboard',
      },
    },
    {
      path: 'sales-assistants',
      name: 'dashboard.sales-assistants.index',
      component: () => import('../modules/dashboard-v5/sales-assistant/index.vue'),
      meta: {
        title: 'AI Agents',
      },
    },
    {
      path: 'sales-assistants/create',
      name: 'dashboard.sales-assistants.create',
      component: () => import('../modules/dashboard-v5/sales-assistant/form.vue'),
      meta: {
        title: 'Create New AI Agents',
        bodyClass: 'subheader-enabled subheader-fixed',
      },
    },
    {
      path: 'sales-assistants/:id',
      name: 'dashboard.sales-assistants.edit',
      component: () => import('../modules/dashboard-v5/sales-assistant/form.vue'),
      meta: {
        title: 'Edit AI Agents',
        bodyClass: 'subheader-enabled subheader-fixed',
      },
    },
    {
      path: 'ai-assistant',
      name: 'dashboard.ai-assistant',
      component: () => import('../modules/dashboard-v5/ai-assistant.vue'),
      meta: {
        title: 'AI Assistant',
      },
    },
    {
      path: 'videos',
      name: 'dashboard.videos',
      component: () => import('../modules/dashboard-v5/videos/list.vue'),
      meta: {
        title: 'Videos',
      },
    },
    {
      path: 'video-replies',
      name: 'dashboard.video-replies',
      component: () => import('../modules/dashboard-v5/videos/video-replies.vue'),
      meta: {
        title: 'Video Replies',
      },
    },
    {
      path: 'video-trash',
      name: 'dashboard.video-trash',
      component: () => import('../modules/dashboard-v5/videos/trash.vue'),
      meta: {
        title: 'Video Trash',
      },
    },
    {
      path: 'contacts',
      name: 'dashboard.contacts.index',
      component: () => import('../modules/dashboard-v5/contacts/index.vue'),
      meta: {
        title: 'Contacts',
      },
    },
    {
      path: 'contacts/:id',
      name: 'dashboard.contacts.show',
      component: () => import('../modules/dashboard-v5/contacts/show.vue'),
      meta: {
        title: 'Contact Details',
        bodyClass: 'subheader-enabled subheader-fixed',
      },
    },
    {
      path: 'deals/board',
      name: 'dashboard.deals.index',
      component: () => import('../modules/dashboard-v5/deals/index.vue'),
      meta: {
        title: 'Deals',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_DEAL,
      },
    },
    {
      path: 'deals/board/:id',
      name: 'dashboard.deals.show',
      component: () => import('../modules/dashboard-v5/deals/index.vue'),
      meta: {
        rolePermission: constants.App_Models_TeamRole.PERMISSION_DEAL,
      },
    },
    {
      path: 'deals/list',
      name: 'dashboard.deals.list',
      component: () => import('../modules/dashboard-v5/deals/list.vue'),
      meta: {
        title: 'Deals',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_DEAL,
      },
    },
    {
      path: 'tasks',
      name: 'dashboard.tasks.index',
      component: () => import('../modules/dashboard-v5/tasks/index.vue'),
      meta: {
        title: 'Tasks',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_TASK,
      },
    },
    {
      path: 'tasks/:id',
      name: 'dashboard.tasks.show',
      component: () => import('../modules/dashboard-v5/tasks/show.vue'),
      meta: {
        title: 'Task Details',
        bodyClass: 'subheader-enabled subheader-fixed',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_TASK,
      },
    },
    {
      path: 'forms',
      name: 'dashboard.forms.index',
      component: () => import('../modules/dashboard-v5/forms/index.vue'),
      meta: {
        title: 'Forms',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_FORM,
      },
    },
    {
      path: 'forms/create',
      name: 'dashboard.forms.create',
      component: () => import('../modules/dashboard-v5/forms/form.vue'),
      meta: {
        title: 'Create New Form',
        bodyClass: 'subheader-enabled subheader-fixed',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_FORM,
      },
    },
    {
      path: 'forms/:id',
      name: 'dashboard.forms.edit',
      component: () => import('../modules/dashboard-v5/forms/form.vue'),
      meta: {
        title: 'Edit Form',
        bodyClass: 'subheader-enabled subheader-fixed',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_FORM,
      },
    },
    {
      path: 'forms/:id/clone',
      name: 'dashboard.forms.clone',
      component: () => import('../modules/dashboard-v5/forms/form.vue'),
      meta: {
        title: 'Clone Form',
        bodyClass: 'subheader-enabled subheader-fixed',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_FORM,
      },
    },
    {
      path: 'scripts',
      name: 'dashboard.scripts.index',
      component: () => import('../modules/dashboard-v5/scripts/index.vue'),
      meta: {
        title: 'Scripts',
      },
    },
    {
      path: 'scripts/create',
      name: 'dashboard.scripts.create',
      component: () => import('../modules/dashboard-v5/scripts/form.vue'),
      meta: {
        title: 'Create New Script',
        bodyClass: 'subheader-enabled subheader-fixed',
      },
    },
    {
      path: 'scripts/:hash_id/edit',
      name: 'dashboard.scripts.edit',
      component: () => import('../modules/dashboard-v5/scripts/form.vue'),
      meta: {
        title: 'Edit Script',
        bodyClass: 'subheader-enabled subheader-fixed',
      },
    },
    {
      path: 'scripts/:hash_id',
      name: 'dashboard.scripts.show',
      component: () => import('../modules/dashboard-v5/scripts/script-preview/script-preview.vue'),
      meta: {
        title: 'View Script',
        bodyClass: 'subheader-enabled subheader-fixed',
      },
    },
    {
      path: 'video-presets',
      name: 'dashboard.video-presets.index',
      component: () => import('../modules/dashboard-v5/video-presets/index.vue'),
      meta: {
        title: 'Video Presets',
      },
    },
    {
      path: 'video-presets/create',
      name: 'dashboard.video-presets.create',
      component: () => import('../modules/dashboard-v5/video-presets/form.vue'),
      meta: {
        title: 'Create New Video Preset',
        bodyClass: 'subheader-enabled subheader-fixed',
      },
    },
    {
      path: 'video-presets/:id/edit',
      name: 'dashboard.video-presets.edit',
      component: () => import('../modules/dashboard-v5/video-presets/form.vue'),
      meta: {
        title: 'Edit Video Preset',
        bodyClass: 'subheader-enabled subheader-fixed',
      },
    },
    {
      path: 'video-presets/:id/clone',
      name: 'dashboard.video-presets.clone',
      component: () => import('../modules/dashboard-v5/video-presets/form.vue'),
      meta: {
        title: 'Clone Video Preset',
        bodyClass: 'subheader-enabled subheader-fixed',
      },
    },
    {
      path: 'showcases',
      name: 'dashboard.showcases.index',
      component: () => import('../modules/dashboard-v5/showcases/index.vue'),
      meta: {
        title: 'Showcases',
      },
    },
    {
      path: 'showcases/create',
      name: 'dashboard.showcases.create',
      component: () => import('../modules/dashboard-v5/showcases/form.vue'),
      meta: {
        title: 'Create New Showcase',
        bodyClass: 'subheader-enabled subheader-fixed',
      },
    },
    {
      path: 'showcases/:hash_id/edit',
      name: 'dashboard.showcases.edit',
      component: () => import('../modules/dashboard-v5/showcases/form.vue'),
      meta: {
        title: 'Edit Showcase',
        bodyClass: 'subheader-enabled subheader-fixed',
      },
    },
    {
      path: 'showcases/:hash_id/clone',
      name: 'dashboard.showcases.clone',
      component: () => import('../modules/dashboard-v5/showcases/form.vue'),
      meta: {
        title: 'Clone Showcase',
        bodyClass: 'subheader-enabled subheader-fixed',
      },
    },
    {
      path: 'companies',
      name: 'dashboard.companies',
      component: () => import('../modules/dashboard-v5/companies.vue'),
      meta: {
        title: 'Companies',
      },
    },
    {
      path: 'reporting',
      name: 'dashboard.reporting',
      component: () => import('../modules/dashboard-v5/reporting.vue'),
      meta: {
        title: 'Reporting',
      },
    },
    {
      path: 'calls-to-action',
      name: 'dashboard.call-to-actions.index',
      component: () => import('../modules/dashboard-v5/call-to-actions/index.vue'),
      meta: {
        title: 'Call To Actions',
      },
    },
    {
      path: 'calls-to-action/:id/edit',
      name: 'dashboard.call-to-actions.edit',
      component: () => import('../modules/dashboard-v5/call-to-actions/form.vue'),
      meta: {
        title: 'Edit Call To Action',
        bodyClass: 'subheader-enabled subheader-fixed',
      },
    },
    {
      path: 'calls-to-action/create',
      name: 'dashboard.call-to-actions.create',
      component: () => import('../modules/dashboard-v5/call-to-actions/form.vue'),
      meta: {
        title: 'Create New Call To Action',
        bodyClass: 'subheader-enabled subheader-fixed',
      },
    },
    {
      path: 'landing-pages',
      name: 'dashboard.landing-pages.index',
      component: () => import('../modules/dashboard-v5/landing-pages/index.vue'),
      meta: {
        title: 'Landing Pages',
      },
    },
    {
      path: 'landing-pages/:id/analytics',
      name: 'dashboard.landing-pages.analytics',
      component: () => import('../modules/dashboard-v5/landing-pages/analytics/analytics.vue'),
      meta: {
        title: 'Landing Page Analytics',
        bodyClass: 'subheader-enabled subheader-fixed',
      },
    },
    {
      path: 'campaigns/email',
      name: 'dashboard.campaigns.email.index',
      component: () => import('../modules/dashboard-v5/campaigns/email/list.vue'),
      meta: {
        title: 'Email Campaigns',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_CAMPAIGN,
      },
    },
    {
      path: 'campaigns/email/create',
      name: 'dashboard.campaigns.email.create',
      component: () => import('../modules/dashboard-v5/campaigns/email/create.vue'),
      meta: {
        title: 'Create New Email Campaign',
        bodyClass: 'subheader-enabled subheader-fixed',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_CAMPAIGN,
      },
    },
    {
      path: 'campaigns/email/:slug/edit/:step?',
      name: 'dashboard.campaigns.email.edit',
      component: () => import('../modules/dashboard-v5/campaigns/email/create.vue'),
      meta: {
        title: 'Edit Email Campaign',
        bodyClass: 'subheader-enabled subheader-fixed',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_CAMPAIGN,
      },
    },
    {
      path: 'campaigns/email/:slug/clone',
      name: 'dashboard.campaigns.email.clone',
      component: () => import('../modules/dashboard-v5/campaigns/email/create.vue'),
      meta: {
        title: 'Clone Email Campaign',
        bodyClass: 'subheader-enabled subheader-fixed',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_CAMPAIGN,
      },
    },
    {
      path: 'campaigns/sms',
      name: 'dashboard.campaigns.sms.index',
      component: () => import('../modules/dashboard-v5/campaigns/sms/list.vue'),
      meta: {
        title: 'SMS Campaigns',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_CAMPAIGN,
      },
    },
    {
      path: 'campaigns/sms/create',
      name: 'dashboard.campaigns.sms.create',
      component: () => import('../modules/dashboard-v5/campaigns/sms/create.vue'),
      meta: {
        title: 'Create New SMS Campaign',
        bodyClass: 'subheader-enabled subheader-fixed',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_CAMPAIGN,
      },
    },
    {
      path: 'campaigns/sms/:slug/edit/:step?',
      name: 'dashboard.campaigns.sms.edit',
      component: () => import('../modules/dashboard-v5/campaigns/sms/create.vue'),
      meta: {
        title: 'Edit SMS Campaign',
        bodyClass: 'subheader-enabled subheader-fixed',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_CAMPAIGN,
      },
    },
    {
      path: 'campaigns/sms/:slug/clone',
      name: 'dashboard.campaigns.sms.clone',
      component: () => import('../modules/dashboard-v5/campaigns/sms/create.vue'),
      meta: {
        title: 'Clone SMS Campaign',
        bodyClass: 'subheader-enabled subheader-fixed',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_CAMPAIGN,
      },
    },
    {
      path: 'workflow',
      name: 'dashboard.workflow.index',
      component: () => import('../modules/dashboard-v5/automation/workflow/list.vue'),
      meta: {
        title: 'Automations',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_WORKFLOW,
      },
    },
    {
      path: 'workflow/create',
      name: 'dashboard.workflow.create',
      component: () => import('../modules/dashboard-v5/automation/workflow/create.vue'),
      meta: {
        title: 'Create New Automation',
        bodyClass: 'subheader-enabled subheader-fixed',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_WORKFLOW,
      },
    },
    {
      path: 'workflow/:slug/edit/:step?',
      name: 'dashboard.workflow.edit',
      component: () => import('../modules/dashboard-v5/automation/workflow/create.vue'),
      meta: {
        title: 'Edit Automation',
        bodyClass: 'subheader-enabled subheader-fixed',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_WORKFLOW,
      },
    },
    {
      path: 'workflow/:slug',
      name: 'dashboard.workflow.view',
      component: () => import('../modules/dashboard-v5/automation/workflow/view.vue'),
      meta: {
        title: 'Automation Results',
        bodyClass: 'subheader-enabled subheader-fixed',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_WORKFLOW,
      },
    },
    {
      path: 'automation/campaigns/email',
      name: 'dashboard.automation.campaigns.email.index',
      component: () => import('../modules/dashboard-v5/automation/campaigns/email-list.vue'),
      meta: {
        title: 'Automation Email Campaigns',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_WORKFLOW,
      },
    },
    {
      path: 'automation/campaigns/sms',
      name: 'dashboard.automation.campaigns.sms.index',
      component: () => import('../modules/dashboard-v5/automation/campaigns/sms-list.vue'),
      meta: {
        title: 'Automation SMS Campaigns',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_WORKFLOW,
      },
    },
    {
      path: 'email-templates',
      name: 'dashboard.email-templates.index',
      component: () => import('../modules/dashboard-v5/email-templates/index.vue'),
      meta: {
        title: 'Email Templates',
        rolePermission: constants.App_Models_TeamRole.PERMISSION_EMAIL_TEMPLATE,
      },
    },
    {
      path: 'coaching',
      name: 'dashboard.coaching',
      component: () => import('../modules/dashboard-v5/coaching.vue'),
      meta: {
        title: 'Dubb Coaching',
      },
    },
    {
      path: 'global-search',
      name: 'dashboard.global-search',
      component: () => import('../modules/dashboard-v5/global-search/index.vue'),
      meta: {
        title: 'Global Search',
      },
    },
  ],
}]
